import React from 'react'
import { Button, Modal } from 'antd'

import './index.less'
import { runTests } from '../../api/different'
import _ from 'lodash'

export default class Tests extends React.Component {
  state = {
    loading: false,
    modalVisible: false,
    testsResult: '',
  };

  render() {
    const startTests = () => {
      this.setState({ loading: true })

      runTests().then((res) => {
        let replaceResult = _.replace(res.result, /Passed/g, `<b style="color:green">ПРОЙДЕН</b> за`)
        replaceResult = _.replace(replaceResult, /Error/g, `<b style="color:red">НЕ ПРОЙДЕН</b> за`)
        this.setState({ loading: false, testsResult: replaceResult, modalVisible: true })
        // console.log(res.result, _.replace( res.result, /Passed/g, <div className="test-success">Пройден</div>))
      }).catch((err) => {
        this.setState({ loading: false, testsResult: 'Ошибка выполнения' })
        // console.log(err)
      })
    }

    const closeModal = (visible) => {
      this.setState({ modalVisible: false })
    }

    return (
      <div>
        <Button type='primary' onClick={startTests} loading={this.state.loading} >Пройти тесты</Button>
        <Modal
          title='Отчет по результатам тестирования'
          visible={this.state.modalVisible}
          onOk={closeModal}
          onCancel={closeModal}
          footer={[]}
        >
          <div className='test-results' dangerouslySetInnerHTML={{ __html: this.state.testsResult }} />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/containers/Tests/index.jsx